module.exports = __webpack_public_path__ + "img/date@2x.98b39a3.webp";